/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const setLangRequestV4Schema = z.object({
  lang: z
    .string()
    .nullish()
    .describe(
      'Two-letter UI language code to switch to — must be an enabled system language (e.g. "lv", "en").'
    ),
})
